export const toggleIOsBounceEffect = (enabled: boolean) => {
  const container = document.querySelector(
    "#content-wrapper"
  ) as HTMLDivElement | null;

  if (!container) {
    return;
  }

  container.style.overflow = enabled ? "" : "hidden";
  document.documentElement.style.overflow = enabled ? "" : "hidden";
};

export const computePointInCanvas = (
  e: MouseEvent | TouchEvent,
  canvasRef: HTMLCanvasElement | null
) => {
  if (e.type === "touchmove" && canvasRef) {
    const touch = (e as TouchEvent).touches[0];
    const { x, y } = canvasRef.getBoundingClientRect();
    return {
      x: touch.clientX - x,
      y: touch.clientY - y
    };
  }

  if (canvasRef) {
    const { offsetX, offsetY } = e as MouseEvent;
    return {
      x: offsetX,
      y: offsetY
    };
  }

  return null;
};
